import { render } from "./RejectionCases.vue?vue&type=template&id=001ead80"
import script from "./RejectionCases.vue?vue&type=script&lang=js"
export * from "./RejectionCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/RejectionCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "001ead80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('001ead80', __exports__)) {
    console.log('reload')
    api.reload('001ead80', __exports__)
  }
  
  module.hot.accept("./RejectionCases.vue?vue&type=template&id=001ead80", () => {
    console.log('re-render')
    api.rerender('001ead80', render)
  })

}


export default __exports__